<template>
    <show-information
        :show="data.show"
        @change-step-next="() => $emit('proceed', data)"
        @change-step-prev="() => $emit('back', data)"
    />
</template>
<script>
import ShowInformation from '@/components/Shows/ShowInformation';

export default {
    components: {
        ShowInformation,
    },

    props: {
        data: {
            type: [Object],
            default: () => ({}),
        },
    },
};
</script>
